import el from '../../assets/json/elements.json'
import msg from '../../assets/json/messages.json'

const state = {
  L: {
    el,
    msg
  }
}

const getters = {
  L: state => state.L
}

export default {
  state,
  getters
}
